(() => {
  if (customElements.get('collection-description')) return;

  class CollectionDescription extends HTMLElement {
    constructor() {
      super();
      this._expanded = false;
      this.onToggle = this.onToggle.bind(this);
      this.onMQLChange = this.onMQLChange.bind(this);
    }

    connectedCallback() {
      this.body = this.querySelector('[data-description-body]');
      this.toggle = this.querySelector('[data-description-toggle]');
      this.label = this.querySelector('[data-toggle-label]');
      if (!this.body || !this.toggle || !this.label) return;

      this.mql = window.matchMedia('(max-width: 749px)');
      this.mql.addEventListener('change', this.onMQLChange);
      this.toggle.addEventListener('click', this.onToggle);

      this.resizeObserver = new ResizeObserver(() => {
        if (this.mql.matches && !this._expanded) this.measureOverflow();
      });
      this.resizeObserver.observe(this.body);

      document.fonts.ready.then(() => {
        if (this.mql.matches && !this._expanded) this.measureOverflow();
      });

      this.applyState();
    }

    disconnectedCallback() {
      this.toggle?.removeEventListener('click', this.onToggle);
      this.mql?.removeEventListener('change', this.onMQLChange);
      this.resizeObserver?.disconnect();
    }

    onMQLChange(e) {
      if (!e.matches) this._expanded = false;
      this.applyState();
    }

    onToggle() {
      this._expanded = !this._expanded;
      this.applyState();
    }

    applyState() {
      const isMobile = this.mql.matches;

      if (!isMobile) {
        this.body.classList.remove('collection-description-block__content--clamped');
        this.toggle.hidden = true;
        return;
      }

      if (this._expanded) {
        this.body.classList.remove('collection-description-block__content--clamped');
        this.toggle.classList.add('collection-description__toggle--expanded');
        this.label.textContent = this.toggle.dataset.readLess;
        this.toggle.hidden = false;
      } else {
        this.body.classList.add('collection-description-block__content--clamped');
        this.toggle.classList.remove('collection-description__toggle--expanded');
        this.label.textContent = this.toggle.dataset.readMore;
        requestAnimationFrame(() => this.measureOverflow());
      }
    }

    measureOverflow() {
      const overflows = this.body.scrollHeight > this.body.clientHeight + 2;
      this.toggle.hidden = !overflows;
    }
  }

  customElements.define('collection-description', CollectionDescription);
})();
